import { Image, Container, Row, Col, Figure } from 'react-bootstrap';
import Img from '../Img/Story/India_Gate.jpg';
import "./Services.css";
import PixelTransition from './PixelTransition';
import { Link } from 'react-router-dom';

//Products
// import Furniture from '../Img/Products/Furniture.jpg';
import Rug from '../Img/Products/Rugs.jpg';
import Cushions from '../Img/Products/Cushions.jpg';
import Towel from '../Img/Products/luxury-bath-towels.jpg';
// import BedBath from '../Img/Products/BedBath.jpg';
// import KitchenDining from '../Img/Products/kitchen-and-dining.jpg';
// import DecorAccessories from '../Img/Products/Decor-Accessories.png';
import Pouf from '../Img/Products/pouf.jpg';
import Curtain from '../Img/Products/Curtons.jpg';
// import Holiday from '../Img/Products/Holiday.jpg';

function OurStory() {
    return (
        <>
            <Image className="fade-in responsive-imgA" src={Img} width="100%" fluid />
            <Container>
                <Row>
                    <Col>
                        <h1 className="my-4 text-center text-decoration-underline"> <strong>Products</strong></h1>
                        <p className='justify-text' style={{ fontSize: '20px' }}>
                            Allow us to introduce you to our fabulous country and its rich crafts.
India is home to a vast array of traditional products: Handmade Textile, Carpets & Rugs, Throws, all variety of Handicrafts products and everyday accessories in beautiful crochet. It also boost some of the most modern industrial units, which produce Towels, cushion covers and other all home décor products at high standard.
Whether you are looking for your brand or value merchandise, India is the ideal destination for every home textile product, Handicrafts and floor covering goods.</p>
                        
                    </Col>
                </Row>
            </Container>
            <Container>
        <h1 className="text-center my-4"><strong>Our Products</strong></h1>
        <Row className="g-4 justify-content-center my-4">
          {/* Furniture */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Furniture" className="shadow-sm border-0"
              style={{maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img
                    src={Furniture}
                    alt="Furniture"
                    style={{width:"100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }}
                  />
                }
                secondContent={
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "grid",
                      placeItems: "center",
                      backgroundColor: "#111",
                      aspectRatio: "4/3",
                    }}
                  >
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>
                      Furniture
                    </p>
                  </div>
                }
                gridSize={12}
                pixelColor="#ffffff"
                animationStepDuration={0.4}
                className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Rug */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Rugs" className="shadow-sm border-0"
              style={{maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Rug} alt="Rug" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Rug</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Cushions */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Cushions" className="shadow-sm border-0"
              style={{maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Cushions} alt="Cushions" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Cushions</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Bed & Bath */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/BedBath" className="shadow-sm border-0"
              style={{ maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={BedBath} alt="BedBath" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Bed & Bath</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Kitchen & Dining */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/KitchenDining" className="shadow-sm border-0"
              style={{maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={KitchenDining} alt="KitchenDining" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Kitchen & Dining</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}

          {/* Accessories */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Towel" className="shadow-sm border-0"
              style={{maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Towel} alt="Accessories" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Towels</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Lights */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Pouf" className="shadow-sm border-0"
              style={{maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Pouf} alt="Lights" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Poufs</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Bags */}
          <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Curtain" className="shadow-sm border-0"
              style={{maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Curtain} alt="Bag" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Curtains</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col>

          {/* Holiday */}
          {/* <Col xs={12} sm={6} md={4} className="d-flex justify-content-center">
            <Figure as={Link} to="/Holiday" className="shadow-sm border-0"
              style={{maxWidth: "360px", borderRadius: "12px", overflow: "hidden" }}>
              <PixelTransition
                firstContent={
                  <img src={Holiday} alt="Holiday" style={{ width: "100%", height: "100%", objectFit: "cover", aspectRatio: "4/3" }} />
                }
                secondContent={
                  <div style={{ width: "100%", height: "100%", display: "grid", placeItems: "center", backgroundColor: "#111", aspectRatio: "4/3" }}>
                    <p variant="outline-light" className="fw-bold" style={{ fontSize: "clamp(1.25rem, 2vw, 2rem)" }}>Holiday</p>
                  </div>
                }
                gridSize={12} pixelColor="#ffffff" animationStepDuration={0.4} className="custom-pixel-card"
              />
            </Figure>
          </Col> */}
        </Row>
      </Container>
        </>
    )
}

export default OurStory